import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Grid } from "@material-ui/core";

import { BorderedBlock } from "../../../../features/common-attributes/components/bordered-block/bordered-block.component";
import { getReviewStages } from "../../../../redux/actions/reviewStagesActions";
import { Heading } from "../../../../components/headers/heading/heading.component";
import { ReviewStageList } from "../../../../components/review-stage-list/review-stage-list/review-stage-list.component";
import {
  selectReviewStages,
  selectReviewStagesLoader,
} from "../../../../redux/selectors/reviewStages";
import { SpinnerLoader } from "../../../../components/loaders";

import { CampaignBriefApprovalsTabProps } from "./campaign-brief-approvals-tab.props";
import { HiddenHeading } from "../../../pages.styles";

export const CampaignBriefApprovalsTab = (props: CampaignBriefApprovalsTabProps) => {
  const dispatch = useDispatch();
  const isLoading = useSelector(selectReviewStagesLoader);

  const pageType = "campaign-briefs";
  const reviewStagesResults = useSelector(selectReviewStages);

  const { id } = useParams<{ id: string }>();

  useEffect(() => {
    if (id) {
      dispatch(getReviewStages(Number(id), pageType));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <HiddenHeading>{props.pageTitle}</HiddenHeading>
        <BorderedBlock>
          <Heading variant="secondary">List of Approvers</Heading>
          <ReviewStageList
            briefStatus={props.status}
            id={id}
            pageType={pageType}
            stages={reviewStagesResults}
            loaded
          />
        </BorderedBlock>
        <SpinnerLoader showIf={isLoading} innerLoader />
      </Grid>
    </Grid>
  );
};
